<template>
  <div class="order">
    <v-app-bar
      app
      color="primary"
      dense
      :class="[{ '' /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col cols="2" style="display: flex">
          <v-app-bar-nav-icon @click="navBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="8" class="d-flex justify-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2"
              >{{ $t($store.getters.orderFrom) }}
              <span class="header-title2-feature">{{ $t("checkout") }}</span></v-toolbar-title
            >
          </div>
        </v-col>

        <v-col cols="2" align-self="end" style="text-align: right"> </v-col>
      </v-row>
    </v-app-bar>

    <v-container class="mt-n3 pb-16" v-if="$store.state.order !== undefined">
      <v-switch
        color="secondary"
        v-model="$store.state.order.dineInAway"
        :label="$t('takeout')"
        :ripple="false"
        v-if="$store.state.order.orderType == $store.state.OT_DINEIN && $store.state.serverBuildNo >= 120"
      ></v-switch>
      <v-switch
        color="secondary"
        v-model="$store.state.order.utensils"
        :label="$t('checkout.utensils')"
        :ripple="false"
        v-if="
          !$store.state.notAskUtensils &&
            ($store.state.order.orderType == $store.state.OT_TAKEOUT ||
              $store.state.order.orderType == $store.state.OT_DELIVERY)
        "
      ></v-switch>

      <cart :currentRouteName="$router.currentRoute.name"></cart>

      <div v-if="$store.getters.suggestedItems.length > 0" class="suggestion-box">
        <div class="t-title">{{ $t("suggestion") }}</div>
        <v-slide-group vx--model="model" show-arrows>
          <v-slide-item v-for="(item, index) in $store.getters.suggestedItems" :key="index">
            <v-card class="ma-2" height="200" width="150" @click="addItem(item)">
              <v-img v-if="item.imageUri != ''" :src="item.imageUri" height="150" width="150" />

              <div :class="[item.imageUri == '' ? 'item-descr-noimage' : 'item-descr']">
                <div v-if="$store.state.descrIndex == 1">{{ item.descr1 }}</div>
                <div v-else-if="$store.state.descrIndex == 2">{{ item.descr2 }}</div>
                <div v-else>{{ item.descr }}</div>
              </div>
              <div class="item-price" v-if="item.price + item.defOptValue != 0">
                <span v-if="item.sub != item.discountedSub" class="item-price-crossout">
                  {{ item.sub | currency }}
                </span>
                {{ item.discountedSub | currency }}
              </div>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </div>

      <div class="order-login-box" v-if="$store.state.order.login != null">
        <div class="t-title">
          {{
            $store.state.order.login.isMember != null && $store.state.order.login.isMember ? $t("member") : $t("guest")
          }}
        </div>
        <div v-if="$store.state.order.login.name != ''">
          {{ $store.state.order.login.name }}
        </div>
        <div v-if="$store.state.order.login.phone1 != ''">
          {{ $store.state.order.login.phone1 }}
        </div>
        <v-btn
          v-if="$store.state.order.login.isMember == null || !$store.state.order.login.isMember"
          color="secondary"
          class="secondaryText--text mt-1"
          small
          @click="changeLoginClicked"
          >{{ $t("change") }}</v-btn
        >
      </div>

      <div
        class="delivery-address-box"
        v-if="$store.state.order.orderType == 'delivery' && $store.state.order.orderItems.length > 0"
      >
        <div class="delivery-address">
          <div class="t-title d-flex">
            <div>{{ $t("delivery_address") }}</div>
            <div class="ml-2" v-if="$store.getters.faceDriveEnabled">
              <v-img class="stripe-powered-by" src="@/assets/imgs/facedrive-foods-logo-icon.png" width="20" />
            </div>
          </div>
          <div class="address">
            <div v-if="$store.state.order.address != null">
              {{ deliveryAddressString }}
              <div
                v-if="
                  $store.state.order.address.phone1 !== undefined &&
                    $store.state.order.address.phone1 != null &&
                    $store.state.order.address.phone1 != ''
                "
              >
                {{ $store.state.order.address.phone1 }}
              </div>

              <div class="t-title mt-4">{{ $t("delivery_instruction") }}</div>
              <v-textarea
                auto-grow
                rows="1"
                dense
                hide-details
                single-line
                class="address"
                v-model="$store.state.order.address.remark"
              >
              </v-textarea>
            </div>
          </div>

          <v-btn color="secondary" class="secondaryText--text" small @click="changeAddressClicked"
            ><div v-if="$store.state.order.address != null">
              {{ $t("address_change") }}
            </div>
            <div v-else>{{ $t("address_enter") }}</div></v-btn
          >
        </div>
      </div>

      <div v-show="showTimeSection" class="order-time-box">
        <div class="t-title">{{ $t("time") }}</div>

        <v-radio-group v-model="orderNow" :mandatory="true">
          <v-radio v-if="orderNowAccept" :value="true">
            <template v-slot:label>
              {{ orderNowLabel }}

              <span v-if="pickupMinVisible" class="order-pickup-min">
                (
                {{
                  $t("checkout.estimate_pickup_min", {
                    pickup_min: $store.state.store.config.pickupMin,
                  })
                }}
                )
              </span>
              <span v-else-if="deliveryMin > 0" class="order-pickup-min">
                (
                {{ deliveryMin }}<span v-if="deliveryMinTo > deliveryMin"> - {{ deliveryMinTo }}</span>
                {{ $t("minutes") }}
                )
              </span>
            </template>
          </v-radio>
          <v-row align="center" v-if="advanceOrderDay > 0 || (scheduleTimes != null && scheduleTimes.length > 0)">
            <v-col cols="6">
              <v-radio class="pickup-time-radio" :label="scheduleTimeLabel" :value="false"></v-radio>
            </v-col>
            <v-col cols="6" v-if="advanceOrderDay == 0">
              <v-select
                :items="scheduleTimes"
                item-text="localTime"
                v-model="scheduleTime"
                hide-details="true"
                dense
                return-object
                @click="orderNow = false"
              ></v-select>
            </v-col>
          </v-row>

          <v-row v-if="advanceOrderDay > 0" class="mt-1">
            <v-col cols="6" sm="3" md="3" lg="2" x-xl="2">
              <v-menu
                v-model="calendarInput"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="scheduleDateString"
                    prepend-icon="mdi-calendar"
                    hide-details="true"
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click="orderNow = false"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="scheduleDateString"
                  :allowed-dates="allowedScheduleDates"
                  @input="scheduleDateSelected"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6" sm="3" md="3" lg="2" x-xl="2">
              <v-select
                :items="scheduleTimes"
                item-text="localTime"
                v-model="scheduleTime"
                hide-details="true"
                dense
                return-object
                @click="orderNow = false"
              ></v-select>
            </v-col>
          </v-row>
        </v-radio-group>

        <div
          class="timezone-abbrev"
          v-if="!$store.getters.storeTimeZoneMatched && $store.getters.storeTimeZoneAbbrev != ''"
        >
          ({{ $store.getters.storeTimeZoneAbbrev }})
        </div>
      </div>

      <div v-if="$store.state.order.orderItems.length > 0">
        <div v-if="!hideOrderRemark">
          <div class="font-weight-bold accent--text mt-4">{{ $t("special_instruction") }}</div>
          <v-textarea
            auto-grow
            rows="3"
            x-filled
            dense
            hide-details
            single-line
            class="order-remark"
            v-model="$store.state.order.memo"
          >
          </v-textarea>
        </div>

        <div v-else class="order-call-for-request">
          {{ $t("call_for_request") }}
        </div>
      </div>

      <div
        v-if="$t('checkout-message') != '' && $t('checkout-message') != 'checkout-message'"
        x-class="checkout-message"
        v-html="$t('checkout-message')"
      >
        <!-- {{ $t("checkout-message") }} -->
      </div>
    </v-container>

    <v-footer fixed v-if="showFooter" :class="{ '': $vuetify.breakpoint.mdAndUp }">
      <div v-if="$store.state.order.orderType == $store.state.OT_DELIVERY" class="footer-minorder">
        <div v-if="isEmptyObject($store.state.order.address)">{{ $t("checkout.no_delivery_address") }}</div>
        <div v-if="!orderNowAccept && scheduleTimes.length == 0 && !refreshing">
          <div v-if="deliveryTransportTime.off">{{ $t("not_acception_delivery_order_today") }}</div>
          <div v-else>
            {{
              $t("not_acception_delivery_order", {
                timeFrom: deliveryTransportTime.timeFrom,
                timeTo: deliveryTransportTime.timeTo,
              })
            }}
          </div>
        </div>

        <div v-if="$store.state.order.minOrder > 0 || minOrderForFreeDelivery > 0">
          <!--           <span v-if="$store.state.order.minOrder > 0 && minOrderForFreeDelivery > 0">
            <span>{{ $t("checkout.min_order") }} : {{ $store.state.order.minOrder | currency }}</span>
            {{
              $t("checkout.min_order_for_free_delivery", {
                min_order: minOrderForFreeDelivery,
              })
            }}
          </span> -->
          <div v-if="$store.state.order.minOrder > $store.state.order.subtotal - $store.state.order.discountValue">
            {{
              $t("checkout.min_order", {
                min_order: $store.state.order.minOrder,
              })
            }}
            <!-- <span>{{ $t("checkout.min_order") }} : {{ $store.state.order.minOrder | currency }}</span> -->
          </div>
          <div v-if="minOrderForFreeDelivery > $store.state.order.subtotal - $store.state.order.discountValue">
            {{ $t("checkout.min_order_for_free_delivery", { min_order: minOrderForFreeDelivery }) }}
          </div>
          <!--         <span class="footer-discounted-subtotal">
          {{ $t("checkout.discounted_subtotal") }}
        </span> -->
        </div>
      </div>

      <div v-if="$store.state.order.orderItems.length > 0">
        <v-row class="footer-button-row">
          <v-col :cols="sendVisible && payVisible ? 6 : 12" v-if="sendVisible">
            <v-btn
              class="footer-send infoText--text"
              block
              tile
              color="info"
              :disabled="sendDisabled"
              @click="checkout(0)"
              >{{ $t(btnSendTitle) }}</v-btn
            >
          </v-col>

          <v-col :cols="sendVisible && payVisible ? 6 : 12" v-if="payVisible">
            <v-btn
              class="footer-pay infoText--text"
              block
              tile
              color="info"
              :disabled="payDisabled"
              @click="checkout($store.state.order.total)"
              >{{ $t(btnPayTitle) }}</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </v-footer>

    <!--     
    <v-bottom-sheet v-model="loginSelector" inset>
      <v-sheet class="text-center rounded-t-xl login-selector">
        <div class="py-3">
          {{ $t("login_as") }}
        </div>

        <div>
          <v-btn
            color="secondary"
            class="secondaryText--text"
            @click="
              $store.state.loginAsGuest = false;
              checkoutBy();
            "
          >
            {{ $t("member") }}
          </v-btn>
        </div>

        <div>
          <v-btn
            color="secondary"
            class="secondaryText--text"
            @click="
              $store.state.loginAsGuest = true;
              checkoutBy();
            "
          >
            {{ $t("guest") }}
          </v-btn>
        </div>

        <div>
          <v-btn color="warning" class="warningText--text" @click="loginSelector = !loginSelector">
            {{ $t("cancel") }}
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet> 
    -->

    <v-bottom-sheet v-model="paymentSelector" inset>
      <v-sheet class="text-center rounded-t-xl payment-selector">
        <div class="total-header">
          <div class="total-label">
            <span class="total-title">{{ $t("total") }}</span
            ><span class="total-value">{{ $store.state.order.total | currency }}</span>
          </div>
          <div
            v-if="$store.state.order.paymentTips !== undefined && $store.state.order.paymentTips.length > 0"
            class="tips-label"
          >
            <span class="tips-title">{{ $t("tips") }}</span
            ><span class="tips-value">{{ $store.state.order.tips | currency }}</span>
          </div>
        </div>

        <v-radio-group
          v-if="$store.state.order.paymentTips !== undefined && $store.state.order.paymentTips.length > 0"
          v-model="tipsSelected"
          mandatory
          class="tips-group"
        >
          <div v-for="(tipsItem, tipsIndex) in $store.state.order.paymentTips" :key="tipsIndex" class="tips-item">
            <v-btn
              v-show="!tipsItem.other || (tipsSelected !== undefined && !tipsSelected.other)"
              rounded
              color="white"
              class="tips-button"
              :disabled="payProcessing"
              @click="tipsSelected = tipsItem"
            >
              <div class="tips-button-content">
                <span>{{ tipsItem.title }}</span
                ><span><v-radio :value="tipsItem"></v-radio></span>
              </div>
            </v-btn>
          </div>

          <div v-if="tipsSelected !== undefined && tipsSelected.other" class="tips-item">
            <v-btn rounded color="white" class="tips-button" :disabled="payProcessing">
              <div class="tips-button-content">
                <v-text-field
                  v-model="tipsSelected.value"
                  filled
                  dense
                  hide-details=""
                  background-color="transparent"
                  class="other-tips-value-input"
                  @input="calculateTips(tipsSelected)"
                ></v-text-field>
                <v-chip-group v-model="tipsSelected.rate" mandatory @change="calculateTips(tipsSelected)">
                  <v-chip active-class="accent" small :value="true">
                    %
                  </v-chip>
                  <v-chip active-class="accent" small :value="false">
                    $
                  </v-chip>
                </v-chip-group>
              </div></v-btn
            >
          </div>
        </v-radio-group>

        <div class="button-container" v-if="merchants != null && merchants.length > 0">
          <div v-for="(merchant, idx) in merchants" :key="idx">
            <v-btn
              v-if="
                merchant == 'stripe' || merchant == 'globalPayment'
                /*(merchant == 'globalPayment' && !$store.getters.doorDashEnabled && !$store.getters.faceDriveEnabled)*/
              "
              rounded
              color="white"
              :class="[
                {
                  'green--text': merchant == 'globalPayment',
                  'blue--text': merchant == 'stripe',
                },
                'creditcard-button',
              ]"
              @click="navName('Payment', { merchant: merchant })"
              >{{ $t("creditcard") }}</v-btn
            >
          </div>
        </div>

        <div
          v-if="
            !$store.getters.doorDashEnabled &&
              !$store.getters.faceDriveEnabled &&
              $store.state.giftcardPaymentEnabled &&
              giftcards !== undefined &&
              giftcards.length > 0
          "
          class="giftcard"
        >
          <div class="t-title">{{ $t("giftcard") }} ( {{ giftcards.length }} )</div>
          <v-btn
            v-show="giftcardSelected == gcIndex + 1"
            rounded
            color="white"
            v-for="(gc, gcIndex) in giftcards"
            :key="gcIndex"
            @click="payByGiftcard(gc)"
            >{{ gc.CardCode | secure }} | {{ gc.CurBalance | currency }}</v-btn
          >
          <v-pagination
            v-show="giftcards.length > 1"
            v-model="giftcardSelected"
            :length="giftcards.length"
            :total-visible="3"
            circle
            class="mt-2"
          ></v-pagination>
        </div>

        <div class="button-container">
          <v-btn rounded color="white" class="warning--text" @click="paymentSelector = !paymentSelector">
            {{ $t("cancel") }}
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <GuestLoginDialog ref="guestLoginDialog"></GuestLoginDialog>
  </div>
</template>

<script>
import GuestLoginDialog from "@/dialogs/GuestLoginDialog";
import Cart from "@/components/Cart.vue";

export default {
  components: {
    GuestLoginDialog,

    Cart,
  },

  data() {
    return {
      refreshing: false,

      sendVisible: false,
      payVisible: false,

      btnSendTitle: "checkout.sendorder",
      btnPayTitle: "checkout.pay",

      orderNowAccept: false,
      orderNow: false,
      scheduleTimes: [],
      scheduleTime: null,

      orderProcessing: false,

      timeZoneAbbrev: "",

      checkingOut: false,
      loginSelector: false,

      paymentSelector: false,

      otherTipsItem: {},
      payProcessing: false,
      tipsSelected: {},
      //giftcards: [],
      giftcardSelected: 1,

      calendarInput: false,
      scheduleDateString: this.toSQLDateString(new Date()),
      scheduleTimeString: null,
    };
  },

  async activated() {
    console.log("Checkout activated");
    console.log("routeFrom", this.$store.state.routeFrom);

    this.checkingOut = false;
    this.refreshing = true;

    let addressChanged = false;

    if (
      this.$store.state.routeFrom.name == "MenuFull" ||
      this.$store.state.routeFrom.name == "MenuCategory" ||
      this.$store.state.routeFrom.name == "MenuItem" ||
      this.$store.state.routeFrom.name == "Login"
    ) {
      this.sendVisible = false;
      this.payVisible = false;
      this.timeZoneAbbrev = "";
      this.orderNowAccept = false;
      this.orderNow = true;
      this.scheduleTimes = [];
      this.scheduleTime = null;

      if (this.merchants == null) {
        this.sendVisible = !this.$store.getters.doorDashEnabled && !this.$store.getters.faceDriveEnabled;
      } else {
        let stripeExists = this.merchants.indexOf("stripe") >= 0;
        let gpExists = this.merchants.indexOf("globalPayment") >= 0;

        if (this.$store.state.order.payment == "skip" || this.$store.state.order.payment == "optional") {
          this.sendVisible = !this.$store.getters.doorDashEnabled && !this.$store.getters.faceDriveEnabled;
        }

        if (this.$store.state.order.payment == "required" || this.$store.state.order.payment == "optional") {
          this.payVisible = stripeExists || gpExists;
        }
      }

      // debug
      /*
      if (this.$devEnv)
        this.sendVisible = true;
        */

      if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) {
        if (this.sendVisible && this.payVisible) {
          this.btnSendTitle = "checkout.takeout.sendorder";
          this.btnPayTitle = "checkout.takeout.pay";
        } else {
          this.btnSendTitle = "checkout.sendorder";
          this.btnPayTitle = "checkout.pay";
        }
      } else if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) {
        if (this.sendVisible && this.payVisible) {
          this.btnSendTitle = "checkout.delivery.sendorder";
          this.btnPayTitle = "checkout.delivery.pay";
        } else {
          this.btnSendTitle = "checkout.sendorder";
          this.btnPayTitle = "checkout.pay";
        }
      } else {
        if (this.sendVisible && this.payVisible) {
          this.btnSendTitle = "checkout.dinein.sendorder";
          this.btnPayTitle = "checkout.dinein.pay";
        } else {
          this.btnSendTitle = "checkout.sendorder";
          this.btnPayTitle = "checkout.pay";
        }
      }

      if (
        this.$store.state.order.orderType == this.$store.state.OT_DELIVERY &&
        this.$store.state.order.orderItems.length > 0
      ) {
        let deliveryAddress;
        if (
          this.$store.state.addressList != null &&
          this.$store.state.addressList.length > 0 &&
          this.isEmptyObject(this.$store.state.order.address)
        ) {
          deliveryAddress = this.$store.state.addressList[0];
        } else {
          deliveryAddress = this.$store.state.order.address;
        }

        if (deliveryAddress != null) addressChanged = await this.changeAddress(deliveryAddress);
      } else {
        this.$set(this.$store.state.order, "address", null);
        this.$set(this.$store.state.order, "deliveryValueByAddress", 0);
        this.$set(this.$store.state.order, "deliveryWithhold", 0);
        this.$set(this.$store.state.order, "deliveryDriveMin", 0);
        this.$set(this.$store.state.order, "deliveryMin", 0);
      }

      this.calculateTotal();
    }

    if (!addressChanged) {
      await this.reloadScheduleTimes();
    }

    this.orderProcessing = false;
    this.refreshing = false;

    //console.log("order", this.$store.state.order);
    //console.log("scheduleTimes", this.scheduleTimes);
  },

  watch: {
    paymentSelector(newValue) {
      if (newValue) {
        this.tipsSelected = {};
        if (this.$store.state.order.paymentTips.length > 0) {
          let defaultTips = this.$store.state.order.paymentTips.find(tipsItem => tipsItem.checked);
          if (defaultTips === undefined) {
            this.tipsSelected = this.$store.state.order.paymentTips[0];
          } else {
            this.tipsSelected = defaultTips;
          }
        }

        this.giftcardSelected = 1;
        //this.giftcards = [];
        if (
          this.giftcardEnabled &&
          this.$store.state.serverBuildNo >= 123 &&
          !(
            this.$store.state.order.orderType == this.$store.state.OT_DELIVERY &&
            (this.$store.getters.doorDashEnabled || this.$store.getters.faceDriveEnabled)
          )
        ) {
          this.dispatchAction("getGiftcards");
          /*
          this.rest_getMemberGiftcards(this.$store.state.member.MemberCode).then(restResult => {
            if (restResult.result == "ok") {
              this.giftcards = restResult.record;
            }
          });
          */
        }
      }
    },

    tipsSelected(newValue) {
      if (newValue) {
        this.calculateTips(newValue);
      }
    },
  },

  computed: {
    showTimeSection() {
      return (
        !this.$store.getters.checkoutPickupTimeIgnored &&
        (this.orderNowAccept ||
          this.advanceOrderDay > 0 ||
          (this.scheduleTimes != null && this.scheduleTimes.length > 0))
      );
    },

    showFooter() {
      return (
        this.$store.state.order != null &&
        (this.sendVisible || this.payVisible) &&
        !this.refreshing /* &&
        (this.orderNowAccept || this.scheduleTimes.length > 0)*/
      );
    },

    hideOrderRemark() {
      let hide = this.$store.state.order.orderType == this.$store.state.OT_DINEIN;
      if (!hide && this.$store.state.store != null && this.$store.state.store.config.hideOrderRemark != null) {
        hide = this.$store.state.store.config.hideOrderRemark;
      }
      return hide;
    },

    selectTimeTitle() {
      let title = "select_pickup";
      if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) {
        title = "select_delivery";
      }
      return title;
    },

    scheduleTimeSelectOptions() {
      return { title: this.$t(this.selectTimeTitle) };
    },

    orderNowLabel() {
      let label = this.$t("time_now");
      if (
        this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT &&
        this.$store.state.order.orderType.takeout != null &&
        this.$store.state.store.config.pickupMin != null &&
        this.$store.state.store.config.pickupMin > 0
      ) {
        label += this.$t("checkout.estimate_pickup_min", {
          pickup_min: this.$store.state.store.config.pickupMin,
        });
      }
      return label;
    },

    scheduleHours() {
      if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT)
        return this.$store.getters.storeInfo.pickupHours;
      else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY)
        return this.$store.getters.storeInfo.transportHours;
      else return this.$store.getters.storeInfo.businessHours;
    },

    scheduleTimeLabel() {
      let label = "";

      if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) {
        label = this.$t("schedule_pickup");
      } else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) {
        label = this.$t("schedule_delivery");
      }

      return label;
    },

    businessHours() {
      if (this.$store.getters.storeInfo == null || this.$store.getters.storeInfo.businessHours == null) return [];
      else return this.$store.getters.storeInfo.businessHours;
    },

    giftcardEnabled() {
      return (
        this.$store.state.memberEnabled &&
        this.$store.state.giftcardEnabled &&
        this.$store.state.order.login.isMember != null &&
        this.$store.state.order.login.isMember
      );
    },

    giftcards() {
      return this.$store.state.giftcards;
    },

    merchants() {
      let n_merchants = null;
      if (this.$store.state.store != null && this.$store.state.store.checkout != null) {
        let checkout = this.$store.state.store.checkout;
        if (checkout.merchants != null) {
          n_merchants = checkout.merchants;
        }
      }

      return n_merchants;
    },

    pickupMinVisible() {
      return (
        this.$store.state.order !== undefined &&
        this.$store.state.store != null &&
        this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT &&
        this.$store.state.store.orderType.takeout != null &&
        this.$store.state.store.config.pickupMin != null &&
        this.$store.state.store.config.pickupMin > 0
      );
    },

    sendDisabled() {
      if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) {
        return (
          this.$store.state.order.minOrder > this.$store.state.order.subtotal - this.$store.state.order.discountValue ||
          this.isEmptyObject(this.$store.state.order.address) ||
          (!this.orderNowAccept && this.scheduleTimes.length == 0)
        );
      } else {
        return false;
      }
    },

    payDisabled() {
      if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) {
        return (
          this.$store.state.order.minOrder > this.$store.state.order.subtotal - this.$store.state.order.discountValue ||
          this.isEmptyObject(this.$store.state.order.address) ||
          (!this.orderNowAccept && this.scheduleTimes.length == 0)
        );
      } else {
        return false;
      }
    },

    pickupMin() {
      return this.$store.state.store != null && this.$store.state.store.config != null
        ? this.$store.state.store.config.pickupMin
        : 0;
    },

    deliveryDriveMin() {
      return this.$store.state.order.deliveryDriveMin != null ? this.$store.state.order.deliveryDriveMin : 0;
    },

    deliveryAddonMinFrom() {
      return this.$store.getters.storeOrderTypes != null
        ? this.$store.getters.storeOrderTypes.delivery.addonMinFrom
        : 0;
    },

    deliveryAddonMinTo() {
      return this.$store.getters.storeOrderTypes != null ? this.$store.getters.storeOrderTypes.delivery.addonMinTo : 0;
    },

    deliveryMin() {
      return this.deliveryDriveMin + this.pickupMin + this.deliveryAddonMinFrom;
    },

    deliveryMinTo() {
      return this.deliveryDriveMin + this.pickupMin + this.deliveryAddonMinTo;
    },

    deliveryTransportTime() {
      let currentTime = new Date();
      let dow = currentTime.getDay();
      let dtHours = this.$store.state.store.info.transportHours;
      if (dtHours.length == 7) {
        return dtHours[dow];
      } else return {};
    },

    advanceOrderDay() {
      if (
        !this.$store.getters.faceDriveEnabled &&
        this.$store.state.store != null &&
        this.$store.state.store.config != null &&
        this.$store.state.store.config.advanceOrderDay != null
      )
        return this.$store.state.store.config.advanceOrderDay;
      else return 0;
    },

    minOrderForFreeDelivery() {
      if (
        this.$store.getters.deliveryAgentChargeUsed &&
        (this.$store.getters.doorDashEnabled || this.$store.getters.faceDriveEnabled)
      )
        return 0;
      else return this.$store.state.order.minOrderForFreeDelivery;
    },
  },

  methods: {
    allowedScheduleDates(val) {
      if (this.scheduleHours != null && this.scheduleHours.length > 0) {
        let today = new Date();
        let maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + this.advanceOrderDay);
        let allowed = val >= this.toSQLDateString(today) && val <= this.toSQLDateString(maxDate);
        if (allowed) {
          let date = this.toDate(val + "T00:00:00" + this.$store.getters.storeInfo.timeZoneUtcOffset);
          if (date != null) {
            let dow = date.getDay();
            //let dayHours = this.businessHours[dow];
            let dayHours = this.scheduleHours[dow];
            //console.log(val, date, dow, dayHours);
            if (dayHours.times.length == 0) return false;
            else {
              return true;
            }
          } else return false;
        }

        return allowed;
      } else return false;
    },

    scheduleDateSelected() {
      this.calendarInput = false;

      this.reloadAdvanceScheduleTimes();
      if (this.scheduleTimes.length > 0) {
        this.scheduleTime = this.scheduleTimes[0];
      }
    },

    addItem(item) {
      console.log("addItem", item);

      let params = { item: item };
      if (item.bItems.length > 0 && this.$store.state.serverBuildNo >= 143) this.navName("OrderBundle", params);
      else this.navName("Order", params);
    },

    editItem(oi) {
      let params = { orderItem: oi };
      if (oi.bundleItems.length > 0 && this.$store.state.serverBuildNo >= 143) {
        this.navName("OrderBundle", params);
      } else {
        this.navName("Order", params);
      }
    },

    removeItem(oi) {
      this.removeOrderItem(oi);
    },

    changeLoginClicked() {
      this.$refs.guestLoginDialog.open().then(logined => {
        if (logined) {
          //
        }
      });
    },

    changeAddressClicked() {
      this.$root.addressListDialog().then(addr => {
        if (addr && addr != null) {
          this.changeAddress(addr, true);
        }
      });
    },

    async reloadScheduleTimes() {
      console.log("reloadScheduleTimes");

      let o_orderNow = this.orderNow;
      let storeOrderHours = await this.rest_canAcceptOrder(
        this.$store.state.order.orderType,
        this.$store.getters.checkOrderLimit,
        this.$store.state.order.deliveryDriveMin
      );
      if (storeOrderHours.result != "ok") return;

      // orderNow is set to false by an unknown reason, workaround: saved the value and restore it
      this.orderNow = o_orderNow;

      this.$store.state.order.checkoutTime = this.toDate(storeOrderHours.currentTime.now_tz);
      this.$store.state.storeOrderHours = storeOrderHours;

      this.orderNowAccept = storeOrderHours.orderNow;
      if (storeOrderHours.orderNow != null && !storeOrderHours.orderNow) this.orderNow = storeOrderHours.orderNow;

      if (this.advanceOrderDay == 0) {
        if (!this.$store.getters.faceDriveEnabled && storeOrderHours.pickupTimes != null)
          this.scheduleTimes = storeOrderHours.pickupTimes;
        else {
          this.scheduleTimes = [];
        }
      } else {
        this.reloadAdvanceScheduleTimes();
      }

      if (this.scheduleTimes.length > 0) {
        if (this.scheduleTime == null) this.scheduleTime = this.scheduleTimes[0];
        else {
          let n_scheduleTime = this.scheduleTimes.find(schdTime => schdTime.date == this.scheduleTime.date);
          if (n_scheduleTime == null) {
            this.scheduleTime = this.scheduleTimes[0];
          } else {
            this.scheduleTime = n_scheduleTime;
          }
        }
      } else {
        this.scheduleTime = null;
      }
    },

    reloadAdvanceScheduleTimes() {
      if (this.$store.getters.storeInfo != null && this.scheduleDateString != "") {
        let times = [];

        let additionalMin = 0;
        if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) additionalMin = this.pickupMin;
        else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) additionalMin = this.deliveryMin;
        additionalMin = Math.ceil(additionalMin / 15) * 15;
        let date = new Date();

        date.setSeconds(0);
        date.setMilliseconds(0);
        date.setMinutes(date.getMinutes() + additionalMin);
        date.setMinutes(Math.ceil(date.getMinutes() / 15) * 15);

        if (this.toSQLDateString(date) < this.scheduleDateString)
          date = this.toDate(this.scheduleDateString + "T00:00:00" + this.$store.getters.storeInfo.timeZoneUtcOffset);

        if (date != null) {
          let scheduleHours = [...this.scheduleHours];
          let dow = date.getDay();
          let dayHours = scheduleHours[dow];
          let dateCal = new Date(date);
          //console.log(dow, dayHours);

          while (this.toSQLDateString(dateCal) == this.toSQLDateString(date)) {
            if (dayHours.times2 == null) {
              let times2 = [...dayHours.times];
              times2.forEach(ele => {
                if (dayHours.timeFrom == ele.from) {
                  let hh = parseInt(ele.from.substr(0, 2));
                  let nn = parseInt(ele.from.substr(3, 2));
                  nn += additionalMin;
                  if (nn >= 60) {
                    nn = nn - 60;
                    hh += 1;
                    if (hh >= 24) {
                      hh = 0;
                    }
                  }
                  ele.from = hh.toString().padStart(2, "0") + ":" + nn.toString().padStart(2, "0");
                }
              });
              this.$set(dayHours, "times2", times2);
              console.log(dayHours);
            }

            let localTime = this.toLocaleTime24String(dateCal);
            let addToList = false;
            dayHours.times2.forEach(t => {
              if (localTime >= t.from && (localTime <= t.to || t.to == "00:00")) {
                addToList = true;
              }
            });

            let date_sql = this.toSQLDateTimeString(dateCal);
            if (addToList) {
              if (
                this.$store.state.orderLimitPerPeriod > 0 &&
                this.$store.state.storeOrderHours != null &&
                this.$store.state.storeOrderHours.orderCountList != null
              ) {
                let ele = this.$store.state.storeOrderHours.orderCountList.find(e => e.time == date_sql);
                if (ele != null) {
                  if (ele.count >= this.$store.state.orderLimitPerPeriod) addToList = false;
                }
              }
            }

            if (addToList) {
              localTime = this.toLocaleTime12String(dateCal);

              let tm = {
                date: date_sql,
                date_tz: dateCal.toISOString(),
                localTime: localTime,
              };
              times.push(tm);

              //console.log(tm);
            }

            dateCal.setMinutes(dateCal.getMinutes() + 15);
          }
        }
        this.scheduleTimes = times;
      } else {
        this.scheduleTimes = [];
      }
    },

    async changeAddress(address, promptError) {
      console.log("changeAddress");

      let quote = await this.getDeliveryQuote(address);
      let quoteOk = quote.result == "ok";
      if (quoteOk) {
        this.$set(this.$store.state.order, "address", quote.address);
        this.$set(this.$store.state.order, "deliveryValueByAddress", quote.deliveryValue);
        this.$set(this.$store.state.order, "deliveryDriveMin", quote.deliveryDriveMin);
        this.$set(this.$store.state.order, "deliveryWithhold", quote.deliveryWithhold);

        this.calculateTotal();
        await this.reloadScheduleTimes();
      } else if (quote.error != null && promptError) {
        this.$root.messageDialog(this.$t("error_address"), "", quote.error);
      }

      return quoteOk;
    },

    async checkout(payAmount) {
      if (this.checkingOut) return;
      this.checkingOut = true;

      if (this.$store.state.order.orderItems.length == 0) {
        this.checkingOut = false;
        return;
      }

      if (this.$store.getters.itemStockEnabled) {
        let countableOrderItems = this.$store.state.order.orderItems.filter(oi => oi.item.countable);
        let countableItems = [];
        countableOrderItems.forEach(oi => {
          let ci = countableItems.find(ci => ci.itemID == oi.ID);
          if (ci == null) countableItems.push({ itemID: oi.ID, qty: oi.qty });
          else ci.qty += oi.qty;
        });

        if (countableItems.length > 0) {
          let countableItemIDs = countableItems.map(ii => ii.itemID);
          let response = await this.rest_getItemSoldout(countableItemIDs);
          if (response.result == "ok" && response.items.length > 0) {
            for (let n = 0; n < response.items.length; n++) {
              let ii = response.items[n];
              let ci = countableItems.find(ci => ci.itemID == ii.ID);

              if (ii.soldout || ci.qty > ii.qty) {
                let itemID = ii.ID;
                let item = this.$store.state.items.find(i => i.ID == itemID);
                if (item != null) {
                  let outOfStockMessage;
                  if (ii.soldout) outOfStockMessage = this.$t("MENU.out_of_stock");
                  else outOfStockMessage = this.$t("checkout.qty_left", { qty: ii.qty });

                  this.$root.messageDialog(
                    this.$store.getters.itemDescr(item),
                    "",
                    outOfStockMessage + "<br>" + this.$t("checkout.remove_item_continue")
                  );

                  this.checkingOut = false;
                  return;
                }
              }
            }
          }
        }
      }

      let promoOIs = this.$store.state.order.orderItems.filter(oi => oi.promo != null);
      if (promoOIs != null) {
        let addAmount = 0;
        let minAmount = 0;
        for (let oi of promoOIs) {
          let getResp = await this.rest_getMemberPromo(this.$store.state.member.MemberCode, oi.promo.PromoteCode);
          let valid = getResp.result == "ok";

          if (!valid) {
            let promoTitle = oi.promo.title;
            if (this.$store.state.descrIndex == 1) promoTitle = oi.promo.title1;
            else if (this.$store.state.descrIndex == 2) promoTitle = oi.promo.title2;

            this.$root.messageDialog(
              this.$t("error_alert_title"),
              "",
              this.$t("error_promo_redeemed", { promo: promoTitle })
            );
            this.checkingOut = false;
            return;
          }

          if (
            oi.promo.MinAmount != null &&
            this.$store.state.order.subtotal - oi.extended < oi.promo.MinAmount &&
            minAmount < oi.promo.MinAmount
          ) {
            addAmount = oi.promo.MinAmount - (this.$store.state.order.subtotal - oi.extended);
            minAmount = oi.promo.MinAmount;
          }
        }
        if (addAmount > 0) {
          addAmount = this.roundNumber(addAmount, 2);
          this.$root.messageDialog(
            this.$t("error_promo_min_order", { amount: minAmount }),
            "",
            this.$t("error_promo_min_order_complete", { amount: addAmount })
          );
          this.checkingOut = false;
          return;
        }
      }

      let notLinkComboCount = 0;
      this.$store.state.order.orderItems.forEach(oi => {
        if (oi.tag != "" && oi.cbRefID == 0 && this.$store.state.sideComboTags.indexOf(oi.tag) >= 0) {
          notLinkComboCount = notLinkComboCount + oi.qty;
        }
      });

      if (notLinkComboCount > 0) {
        let res = await this.$root.confirmDialog(
          this.$t("confirm_title"),
          "",
          this.$t("confirm_continue_checkout", {
            not_link_combo_count: notLinkComboCount,
          })
        );

        if (!res) {
          this.checkingOut = false;
          return;
        }
      }

      this.refreshing = true;

      let canAcceptOrder = false;
      let scheduleTime = { ...this.scheduleTime };
      let validateScheduleTime = !this.orderNow && this.$store.getters.checkOrderLimit;
      if (validateScheduleTime) await this.reloadScheduleTimes();
      else {
        let storeOrderHours = await this.rest_canAcceptOrder(this.$store.state.order.orderType);
        if (storeOrderHours.result == "ok") {
          this.$store.state.storeOrderHours = storeOrderHours;
        }
      }

      this.refreshing = false;

      canAcceptOrder = this.$store.getters.acceptOrder;

      if (!canAcceptOrder) {
        this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));

        this.checkingOut = false;
        return;
      } else if (validateScheduleTime) {
        let obj = this.scheduleTimes.find(x => x.date_tz == scheduleTime.date_tz);
        if (obj == null) {
          this.$root.messageDialog(
            this.$t("not_acception_order"),
            "",
            this.$t("checkout.time_slot_not_available", { time: scheduleTime.date })
          );

          this.checkingOut = false;
          return;
        }
      }

      this.placeOrder(payAmount);

      this.checkingOut = false;
    },

    async placeOrder(payAmount) {
      console.log("placeorder");

      //console.log(this.$store.state.storeOrderHours);
      if (this.$store.state.member != null) {
        if (this.$store.state.member.MemberPointBalance < this.$store.state.order.redeemedPointsTotal) {
          this.$root.messageDialog(this.$t("error_alert_title"), "", this.$t("error_non_sufficient_points"));
          return;
        }
      }

      this.$store.state.order.orderNow = this.orderNow;

      let n_storeTel = "";
      if (this.$store.getters.storeAddress.tel != null && this.$store.getters.storeAddress.tel != "") {
        n_storeTel = this.$store.getters.storeAddress.tel;
      }

      if (this.$store.state.order.doorDashDriveID != null) this.$store.state.order.doorDashDriveID = undefined;
      if (this.$store.state.order.faceDriveEnabled != null) this.$store.state.order.faceDriveEnabled = undefined;

      if (this.$store.getters.doorDashEnabled) {
        let res = await this.rest_doorDashEstimate({
          deliveryTime: this.orderNow ? new Date() : this.toDate(this.scheduleTime.date),
        });
        if (res.result == "ok") {
          let pickupTime = this.toDate(res.data.pickup_time);
          let deliveryTime = this.toDate(res.data.delivery_time);
          let deliveryDriveMin = Math.ceil((deliveryTime - pickupTime) / 60 / 1000);

          this.$set(this.$store.state.order, "doorDashDriveID", res.DriveId);
          this.$set(this.$store.state.order, "deliveryDriveMin", deliveryDriveMin);
          this.$set(this.$store.state.order, "pickupTime", pickupTime);
          this.$set(this.$store.state.order, "deliveryTime", deliveryTime);

          if (this.$store.getters.deliveryAgentChargeUsed) {
            this.$set(this.$store.state.order, "deliveryValueByAddress", res.data.fee / 100);
            this.calculateTotal();
          }
        }
      } else if (this.$store.getters.faceDriveEnabled) {
        let pickupTime;
        let deliveryTime;
        let deliveryTimeTo;

        if (this.orderNow) {
          pickupTime = this.toDate(this.$store.state.storeOrderHours.currentTime.now_tz);
          pickupTime.setMinutes(pickupTime.getMinutes() + this.$store.state.store.config.pickupMin);

          deliveryTime = this.toDate(this.$store.state.storeOrderHours.currentTime.now_tz);
          deliveryTime.setMinutes(deliveryTime.getMinutes() + this.deliveryMin);
        } else if (this.scheduleTime != null) {
          pickupTime = this.toDate(this.scheduleTime.date_tz);
          pickupTime.setMinutes(pickupTime.getMinutes() - this.$store.state.order.deliveryDriveMin);

          deliveryTime = this.toDate(this.scheduleTime.date_tz);
        }

        if (this.deliveryAddonMinFrom < this.deliveryAddonMinTo) {
          deliveryTimeTo = new Date(deliveryTime);
          deliveryTimeTo.setMinutes(
            deliveryTimeTo.getMinutes() + (this.deliveryAddonMinTo - this.deliveryAddonMinFrom)
          );
        }

        this.$set(this.$store.state.order, "faceDriveEnabled", true);
        this.$set(this.$store.state.order, "pickupTime", pickupTime);
        this.$set(this.$store.state.order, "deliveryTime", deliveryTime);
        this.$set(this.$store.state.order, "deliveryTimeTo", deliveryTimeTo);
      } else if (!this.$store.getters.checkoutPickupTimeIgnored) {
        if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) {
          let pickupTime = null;
          if (this.orderNow) {
            pickupTime = this.toDate(this.$store.state.storeOrderHours.currentTime.now_tz);
            pickupTime.setMinutes(pickupTime.getMinutes() + this.$store.state.store.config.pickupMin);
          } else if (this.scheduleTime != null) {
            pickupTime = this.toDate(this.scheduleTime.date_tz);
          }
          this.$store.state.order.pickupTime = pickupTime;
          this.$store.state.order.deliveryTime = null;
          this.$store.state.order.deliveryTimeTo = null;
        } else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) {
          let pickupTime;
          let deliveryTime;
          let deliveryTimeTo;
          if (this.orderNow) {
            pickupTime = this.toDate(this.$store.state.storeOrderHours.currentTime.now_tz);
            pickupTime.setMinutes(pickupTime.getMinutes() + this.$store.state.store.config.pickupMin);

            deliveryTime = this.toDate(this.$store.state.storeOrderHours.currentTime.now_tz);
            deliveryTime.setMinutes(deliveryTime.getMinutes() + this.deliveryMin);

            if (this.deliveryMinTo > this.deliveryMin) {
              deliveryTimeTo = this.toDate(this.$store.state.storeOrderHours.currentTime.now_tz);
              deliveryTimeTo.setMinutes(deliveryTimeTo.getMinutes() + this.deliveryMinTo);
            }
          } else if (this.scheduleTime != null) {
            pickupTime = this.toDate(this.scheduleTime.date_tz);
            pickupTime.setMinutes(pickupTime.getMinutes() - this.$store.state.order.deliveryDriveMin);

            deliveryTime = this.toDate(this.scheduleTime.date_tz);

            if (
              this.$store.getters.storeOrderTypes.delivery.addonMinTo >
              this.$store.getters.storeOrderTypes.delivery.addonMin
            ) {
              deliveryTimeTo = this.toDate(this.scheduleTime.date_tz);
              deliveryTimeTo.setMinutes(
                deliveryTimeTo.getMinutes() -
                  this.$store.getters.storeOrderTypes.delivery.addonMinFrom +
                  this.$store.getters.storeOrderTypes.delivery.addonMinTo
              );
            }
          }
          this.$store.state.order.pickupTime = pickupTime;
          this.$store.state.order.deliveryTime = deliveryTime;
          this.$store.state.order.deliveryTimeTo = deliveryTimeTo;
        }
      } else {
        this.$store.state.order.pickupTime = null;
        this.$store.state.order.deliveryTime = null;
        this.$store.state.order.deliveryTimeTo = null;
      }

      if (this.$devEnv) this.orderToFeed();

      if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) {
        if (
          this.$store.state.order.address == null ||
          this.$store.state.order.address.street == null ||
          typeof this.$store.state.order.address != "object"
        ) {
          this.$root.messageDialog(this.$t("error_address"), "", this.$t("message_provide_delivery_address"));
          return;
        }
      }

      this.refreshing = true;

      this.rest_isServerOnline().then(onlineRes => {
        if (onlineRes.result == "ok") {
          this.orderProcessing = true;

          let maxDistance = 0;
          if (this.$store.state.order.orderType != this.$store.state.OT_DELIVERY)
            maxDistance = this.$store.state.order.distance;

          if (maxDistance > 0) {
            this.checkDistance(maxDistance /*, myAddress*/)
              .then(res => {
                this.refreshing = false;

                if (res.result == "ok") {
                  if (payAmount == 0) {
                    this.confirmSendOrder();
                  } else {
                    this.payOrder();
                  }
                } else {
                  this.$root.messageDialog(this.$t("error_location"), "", res.message);
                  this.orderProcessing = false;
                }
              })
              .catch(error => {
                this.refreshing = false;

                this.$root.messageDialog(this.$t("error_location"), "", error.message);
                this.orderProcessing = false;
              });
          } else {
            this.refreshing = false;

            if (payAmount == 0) {
              this.confirmSendOrder();
            } else {
              this.payOrder();
            }
          }
        } else {
          this.refreshing = false;

          let errorMessage = this.$t("error_order_server_unavailable");
          if (n_storeTel != "")
            errorMessage = this.$t("error_order_server_unavailable_with_tel", { store_tel: n_storeTel });
          this.$root.messageDialog(this.$t("error_alert_title"), "", errorMessage);
        }
      });
    },

    confirmSendOrder() {
      let confirmTitle = this.$t("confirm_sendorder");
      let confirmMessage = "";

      let timeZoneAbbrev = "";
      if (!this.$store.getters.storeTimeZoneMatched && this.$store.getters.storeTimeZoneAbbrev != "")
        timeZoneAbbrev = " (" + this.$store.getters.storeTimeZoneAbbrev + ")";

      //let today = new Date();
      if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) {
        let pickupTime = this.toLocaleString(this.$store.state.order.pickupTime);
        let pickupAt = this.$store.getters.checkoutPickupTimeIgnored
          ? ""
          : "<br>" + this.$t("checkout.pickup_at") + "<br>" + pickupTime + timeZoneAbbrev + "<br>";
        confirmMessage =
          pickupAt +
          "<br>" +
          this.$t("pickup_address") +
          "<br>" +
          this.$store.getters.storeName +
          "<br>" +
          this.storeAddressString;
      } else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) {
        let deliveryTime = this.toLocaleString(this.$store.state.order.deliveryTime);
        if (this.$store.state.order.deliveryTimeTo != null)
          deliveryTime += " - " + this.toLocaleTimeString(this.$store.state.order.deliveryTimeTo);
        let deliveryAt = this.$store.getters.checkoutPickupTimeIgnored
          ? ""
          : "<br>" + this.$t("checkout.delivery_at") + "<br>" + deliveryTime + timeZoneAbbrev + "<br>";
        confirmMessage = deliveryAt + "<br>" + this.$t("delivery_address") + "<br>" + this.deliveryAddressString;
      } else {
        /*
        confirmMessage = "<p>" + this.$t("address");
        confirmMessage += "<br>" + this.storeAddressString;
        */
      }
      confirmMessage += (confirmMessage == "" ? "" : "<br><br>") + this.$t("checkout_message");

      this.$root.confirmDialog(confirmTitle, "", confirmMessage).then(resp => {
        if (resp) {
          this.sendOrder();
        } else {
          this.orderProcessing = false;
        }
      });
    },

    async sendOrder() {
      this.$store.state.order.tips = 0;
      this.$store.state.order.payAmount = 0;
      this.$store.state.order.payData = null;

      this.refreshing = true;
      let resp = await this.sendOrderToServer();
      this.refreshing = false;
      if (resp.result == "ok") {
        this.navMenu();
      } /* else {
        let message = this.$t("error_send_order");
        if (resp.messageCode != "") message = this.$t(resp.messageCode);
        else if (resp.message != "") message = resp.message;
        this.$root.messageDialog(this.$t("error_alert_title"), "", message);
      }  */
      this.orderProcessing = false;
    },

    payOrder() {
      this.$store.state.order.tips = 0;

      if (this.$store.state.giftcardEnabled || this.$store.state.order.paymentTips.length > 0) {
        this.paymentSelector = true;
      } else {
        this.navName("Payment");
      }
    },

    payByGiftcard(giftcard) {
      if (this.payProcessing) return;
      if (this.$store.state.order.tips < 0) return;

      this.payProcessing = true;
      let redeemValue = this.$store.state.order.total + this.$store.state.order.tips;
      let cardCode = this.$options.filters.secure(giftcard.CardCode);

      this.$root
        .confirmDialog(
          this.$t("confirm_title"),
          "",
          this.$t("confirm_giftcard_redeem", {
            redeem_value: redeemValue,
            card_no: cardCode,
          })
        )
        .then(resp => {
          if (resp) {
            this.rest_redeemMemberGiftcard(giftcard.CardCode, redeemValue).then(restResult => {
              if (restResult.result == "ok") {
                this.$store.state.order.payAmount = this.roundNumber(
                  this.$store.state.order.total + this.$store.state.order.tips,
                  2
                );
                this.$store.state.order.payData = {
                  type: "giftcard",
                  cardCode: restResult.CardCode,
                  transNo: restResult.TransNo,
                };

                this.sendOrderToServer()
                  .then(data => {
                    if (data.result == "ok") {
                      this.payProcessing = false;
                      this.navMenu();
                    } else {
                      this.payProcessing = false;
                    }
                  })
                  .catch(error => {
                    this.$root.messageDialog(this.$t("error_alert_title"), "", error);
                    this.payProcessing = false;
                  });
              } else {
                this.$root.messageDialog(this.$t("error_alert_title"), "", restResult.result);
                this.payProcessing = false;
              }
            });
          } else {
            this.payProcessing = false;
          }
        });
    },

    calculateTips(tipsItem) {
      let tipsValue = parseFloat(tipsItem.value);
      if (isNaN(tipsValue)) {
        tipsValue = 0;
      }

      if (tipsItem.rate) this.$store.state.order.tips = this.$store.state.order.total * (tipsValue / 100);
      else this.$store.state.order.tips = tipsValue;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";

.container {
  margin-bottom: 40px;
}

.suggestion-box {
  padding: 20px 0px;

  .t-title {
    color: var(--v-accent-base);
    font-weight: bold;
  }

  .item-descr {
    max-height: 25px;
    height: 25px;
    width: 100%;
    padding: 2px 4px;

    div {
      width: 100%;
      font-size: 0.9em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
  }

  .item-descr-noimage {
    @extend .item-descr;

    max-height: 175px;
    height: 175px;

    div {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .item-price {
    max-height: 25px;
    max-width: 100%;
    padding: 0px 4px;
    text-align: center;
    font-weight: bold;
  }
}

.order-login-box {
  padding: 20px 0px;

  .t-title {
    color: var(--v-accent-base);
    font-weight: bold;
  }
}

.delivery-address-box {
  /*   border-bottom-color: rgb(200, 200, 200);
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  .delivery-address {
    .t-title {
      color: var(--v-accent-base);
      font-weight: bold;
    }

    .address {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}

.order-time-box {
  padding: 20px 0px;
  border-bottom-color: rgb(200, 200, 200);
  border-bottom-style: solid;
  border-bottom-width: 1px;

  .t-title {
    color: var(--v-accent-base);
    font-weight: bold;
  }

  .col {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .pickup-time-radio {
    padding-top: 16px;
  }

  .order-pickup-min {
    color: var(--v-accent-base);
    padding-left: 5px;
  }
}

.timezone-abbrev {
  text-align: right;
  margin: 0px;
  margin-right: 15px;
  padding: 0px;

  font-size: 0.75em;
}

.checkout-message {
  margin: 24px 24px;
  text-align: center;
  color: var(--v-accent-base);
  font-size: 1.2em;
  //line-height: 2;
  letter-spacing: 3px;
}

.v-footer {
  padding: 0px;
  padding-bottom: calc(env(safe-area-inset-bottom));

  > div {
    width: 100%;
  }

  .footer-minorder {
    padding: 10px 5px;
    text-align: center;
    font-size: 0.85em;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: var(--v-accent-base);
  }

  .footer-button-row {
    .col {
      padding: 0px 1px;
    }

    .footer-send {
      color: var(--v-infoText-base);
      font-size: 1em;
      padding: 0px 1px;
    }

    .footer-pay {
      color: var(--v-infoText-base);
      font-size: 1em;
      padding: 0px 1px;
    }
  }
}

.login-selector {
  overflow: auto;
  max-height: 90vh;

  padding: 16px;
  .v-btn {
    //padding: 16px;
    margin: 8px;
    width: 90%;
  }
}

.payment-selector {
  overflow: auto;
  max-height: 90vh;

  padding: 16px;

  .v-btn {
    padding: 0px 20px;
    width: 200px;
    height: 40px;
  }

  .total-header {
    .total-label {
      text-align: center;
      margin-bottom: 10px;
    }

    .total-title {
      margin-right: 5px;
      font-size: 1.2em;
    }

    .total-value {
      font-size: 1.8em;
    }
  }

  .button-container {
    padding: 8px;

    .v-btn {
      margin: 8px 8px;
    }
  }

  .tips-group {
    .tips-item {
      text-align: center;
      .tips-button {
        margin: 8px;
        .tips-button-content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }

    .other-tips-value-input {
      width: 30px;
      font-size: 1em;
      .v-input__slot {
        padding: 0px;
      }
    }
  }

  .giftcard {
    padding: 16px;
    .t-title {
      padding: 8px;
    }
  }
}
</style>
